export const mergeRequestApiConfig = {
    mergeList: [],
    setMergeApi: function (api, config) {
        this.mergeList = [
            ...this.mergeList,
            {
                mergeApi: api,
                mergeConfig: config || {},
                requestQueue: [],
                requestTimer: null,
                requestCount: 0
            }
        ]
    },
    removeMergeApi: function (api) {
        this.mergeList = this.mergeList.filter(item => String(item.mergeApi) !== String(api))
    }
}

function sliceString(str, prefix) {
    const regex = new RegExp(`^${prefix}`)
    return str?.replace(regex, '')
}

// 获取匹配
function getMergeData(apiUrl) {
    const mergeList = mergeRequestApiConfig.mergeList

    for (let index = 0; index < mergeList.length; index++) {
        const mergeItem = mergeList[index]
        const { mergeApi } = mergeItem

        if (apiUrl === mergeApi) {
            return mergeItem
        }

        if (mergeApi instanceof RegExp && mergeApi.test(apiUrl)) {
            return mergeItem
        }
    }

    return {
        mergeApi: null,
        mergeConfig: {}
    }
}

/**
 * 合并请求的中间件
 * @param {ctx} ctx - 上下文对象，包括 req 和 res 对象
 * @param {next} next - 调用下一个中间件的函数
 * @param {instance} instance - request实例
 * @returns
 */
export const createRequestAutoMergedMiddleware = async (ctx, next, instance) => {
    const { options, url } = ctx.req || {}
    const paramsKey = options?.method?.toLocaleUpperCase() === 'POST' ? 'data' : 'params'
    const apiUrl = sliceString(options.url || url, options.prefix)
    const mergeItem = getMergeData(apiUrl)

    const { mergeApi, mergeConfig } = mergeItem
    const { mergeFn, debounceTime = 100, maxMergeCount = 3 } = mergeConfig || {}
    let { requestQueue } = mergeItem

    if (mergeApi && typeof mergeFn === 'function' && !options.mergedSentRequest) {
        const submitQueue = async () => {
            mergeItem.requestTimer = null
            const _queue = [...requestQueue]
            mergeItem.requestQueue = []

            if (!_queue.length) {
                return
            }

            try {
                const postValues = mergeFn(_queue.map(v => v.options))

                const list = await instance[options.method.toLowerCase()](apiUrl, {
                    ...options,
                    [paramsKey]: postValues,
                    mergedSentRequest: true // 合并后发起的请求标志，不加的话会死循环
                })

                _queue.forEach(q1 => {
                    q1.ctx.res = list
                    q1.resolve(list)
                })
            } catch (err) {
                console.error(err)
                _queue.forEach(q2 => {
                    q2.ctx.res = err
                    q2.reject(err)
                })
            } finally {
                mergeItem.requestCount = 0
            }
        }

        const debouncedSubmitQueue = () => {
            if (mergeItem.requestTimer) {
                clearTimeout(mergeItem.requestTimer)
            }

            mergeItem.requestTimer = setTimeout(() => {
                submitQueue()
            }, debounceTime)
        }

        return new Promise((resolve, reject) => {
            requestQueue.push({
                options: ctx.req.options[paramsKey],
                resolve,
                reject,
                ctx
            })

            mergeItem.requestCount++

            if (mergeItem.requestCount >= maxMergeCount) {
                clearTimeout(mergeItem.requestTimer)
                submitQueue()
            } else {
                debouncedSubmitQueue()
            }
        })
    }

    await next()
    return
}
